import { render } from "./app-button-business-status.vue?vue&type=template&id=7c66687e&scoped=true"
import script from "./app-button-business-status.vue?vue&type=script&lang=js"
export * from "./app-button-business-status.vue?vue&type=script&lang=js"

import "./app-button-business-status.vue?vue&type=style&index=0&id=7c66687e&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c66687e"]])

export default __exports__